import api from "@/lib/api";

// Internal RecoverOS product analytics — stays inside RecoverOS (db.events), never sent to Meta.
// Use for feature usage, exports, uploads, insight views, etc.

// Stable per-browser id so anonymous → signed-in events can be stitched into one funnel.
function sessionId() {
  try {
    let id = localStorage.getItem("ros_sid");
    if (!id) {
      id = `sid_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem("ros_sid", id);
    }
    return id;
  } catch (e) {
    return "sid_unknown";
  }
}

function device() {
  const u = (navigator.userAgent || "").toLowerCase();
  if (u.includes("ipad") || u.includes("tablet")) return "tablet";
  if (u.includes("mobi") || u.includes("iphone") || u.includes("android")) return "mobile";
  return "desktop";
}

export function logEvent(name, props = {}) {
  try {
    const enriched = { session_id: sessionId(), device: device(), path: window.location.pathname, ...props };
    api.post("/events", { name, props: enriched }).catch(() => {});
  } catch (e) { /* noop */ }
}
